var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentPendingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13659_10285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 9C8.86396 9 10.375 7.48896 10.375 5.625C10.375 3.76104 8.86396 2.25 7 2.25C5.13604 2.25 3.625 3.76104 3.625 5.625C3.625 7.48896 5.13604 9 7 9Z",
    fill: "#D3E9E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875 12L15.625 15.75M15.625 12L11.875 15.75M8.5 11.625H5.125C4.07833 11.625 3.55499 11.625 3.12914 11.7542C2.17034 12.045 1.42003 12.7953 1.12918 13.7541C1 14.18 1 14.7033 1 15.75M10.375 5.625C10.375 7.48896 8.86396 9 7 9C5.13604 9 3.625 7.48896 3.625 5.625C3.625 3.76104 5.13604 2.25 7 2.25C8.86396 2.25 10.375 3.76104 10.375 5.625Z",
    stroke: "#24352F",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13659_10285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentPendingIcon);
export default __webpack_public_path__ + "static/media/payment-pending-icon.8631d975.svg";
export { ForwardRef as ReactComponent };